import React from "react";

import { useForgot } from "./useForgot.tsx";
import ForgotUI from "./Forgot.ui.tsx";

const Forgot: React.FC = () => {
  const forgotProps = useForgot();

  return <ForgotUI {...forgotProps} />;
};

export default Forgot;
